<template>
  <v-card class="board__card" rounded="lg" @dblclick="showAppointment(item.id)">
    <div
      v-if="hasUrgencyPriority && item.status === 'OPEN'"
      class="board__card-urgent"
    >
      <v-chip color="red" dark x-small>
        <div class="d-flex align-center">
          <span class="board__card-urgent-pulse" />
          {{ $t('board.card.urgent') }}
        </div>
      </v-chip>
    </div>

    <BoardCardTitle
      :date="item.date"
      :code="item.code"
      :type="item.type"
      :itemId="item.id"
      :slotSize="item.slot_size"
      :column="column"
      :hasVisitorOrTenant="hasVisitorOrTenant"
      :appointment="item"
    />

    <BoardItemRealties :realties="item.realties" />

    <div v-if="boardDensity === 'DEFAULT'">
      <BoardCardPersons
        :type="item.type"
        :host="item.host"
        :visitor="item.visitor_name"
       />

      <BoardRealtiesList
        v-if="item.realties && item.realties.length"
        :realties="item.realties"
      />

      <BoardCardLocation
        :host="item.host"
        :visitor="item.visitor_name"
        :meeting="item.meeting_location"
        :keyLocation="item.key_location"
      />

      <BoardCardBadges
        v-if="column === 'OPEN' && item.reschedule_date"
        :label="$t('board.badges.canceledByHost')"
        :badgeColor="'CANCELED'"
      />

      <BoardCardBadges
        v-if="item.started && item.status == 'SCHEDULED'"
        :label="'board.badges.hasStarted'"
        :badgeColor="'SCHEDULED'"
      />

      <BoardCardBadges
        v-if="isAustralian && (!item.confirmation || !item.confirmation.confirmed)"
        :label="'board.badges.notConfirmed'"
        :badgeColor="'CANCELED'"
      />

      <BoardOutputs :item="item" :column="column" />

      <div
        class="board__card-comments"
        v-if="
          (column === 'CANCELED' && item.cancel_description) ||
            item.observations ||
            showTimeDifference(item)
        "
      >
        <div class="grey lighten-4">
          <BoardCardCancelContent
            v-if="column === 'CANCELED'"
            :cancelReason="item.cancel_description"
          />
        </div>
        <BoardCardTimeUntilSchedule
          v-if="showTimeDifference(item)"
          :scheduled-time="item.date"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import BoardCardTitle from '../card/BoardCardTitle'
import BoardCardBadges from '../card/BoardCardBadges'
import BoardCardPersons from '../card/BoardCardPersons'
import BoardCardLocation from '../card/BoardCardLocation'
import BoardCardCancelContent from '../card/BoardCardCancelContent'
import BoardCardTimeUntilSchedule from '../card/BoardCardTimeUntilSchedule'
import BoardCardObservationContent from '../card/BoardCardObservationContent'
import BoardOutputs from '../card/BoardOutputs'
import BoardItemRealties from '../../BoardItemRealties'
import BoardRealtiesList from '../card/BoardRealtiesList'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'BoardCard',

  components: {
    BoardCardTitle,
    BoardCardBadges,
    BoardCardPersons,
    BoardCardLocation,
    BoardItemRealties,
    BoardCardCancelContent,
    BoardCardObservationContent,
    BoardCardTimeUntilSchedule,
    BoardOutputs,
    BoardRealtiesList,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },

    column: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['boardDensity']),

    hasVisitorOrTenant() {
      return this.item.visitor_name !== null
    },

    isAustralian() {
      return localStorage.getItem('user_country') == 'AU'
    },

    hasUrgencyPriority() {
      return ['URGENT', 'URGENT_WITHOUT_TAX'].includes(this.item.priority)
    }
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen']),
    ...mapActions(['fetchAppointment']),

    showAppointment(id) {
      this.fetchAppointment(id)
      this.setIsDrawerOpen(true)
    },

    showTimeDifference({ date, status }) {
      return (
        this.checkScheduleTimer(date, 8) &&
        (status == 'OPEN' || status == 'SCHEDULED')
      )
    },

    checkDateDiff(date) {
      return new Date(date).getTime() - new Date().getTime()
    },

    checkScheduleTimer(date, hours) {
      const diff = this.checkDateDiff(date)
      if (hours) return diff > 0 && diff <= hours * 60 * 60 * 1000
      return diff > 0
    },
  },
}
</script>
